import React from "react";
import style from "./footer.module.css";
import telegram from "../../assets/images/telegram.svg";
import reddit from "../../assets/images/reddit.svg";
import discord from "../../assets/images/discord.svg";
import twitter from "../../assets/images/twitter.svg";
import instagram from "../../assets/images/instagram.svg";

const socials = [
  {
    icon: telegram,
    name: "Telegram",
    link: "https://t.me/dingertoken",
  },
  {
    icon: reddit,
    name: "Reddit",
    link: "https://www.reddit.com/r/schrodinger/",
  },
  {
    icon: discord,
    name: "Discord",
    link: "https://discord.gg/u426hmda5T",
  },
  {
    icon: twitter,
    name: "Twitter",
    link: "https://www.twitter.com/dingertoken",
  },
  {
    icon: instagram,
    name: "Instagram",
    link: "https://www.instagram.com/schrodingertoken/",
  },
];

function Footer() {
  console.log(`Built by Embrace Tech
  (https://t.me/OnChainDetective)
    
 `);
  return (
    <>
      <div className={style.footer_container}>
        <div className={`${style.footer_wrapper}`}>
          <div className={style.footer_cright}>
            <div className={style.footer_cright_container}>
              <p>
                Schro-Dinger &copy; {new Date().getFullYear()}. All rights
                reserved.
              </p>
              {/* <span className="brandon-g-reg-13 pt-0 pb-2">
                Built by{" "}
                <a
                  className="text-c_FFDE00"
                  href="https://t.me/OnChainDetective"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Embrace Tech
                </a>
              </span> */}
              <span className="brandon-g-reg-13 pt-0 pb-2">
                <a
                  className="text-c_FFDE00"
                  href="https://www.certik.com/projects/dinger-token"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Certik Audited! &#8594;
                </a>
              </span>
            </div>
          </div>

          <div className={style.footer_socials}>
            {socials.map(({ icon, name, link }, indx) => {
              return (
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={indx}
                  className="p-2"
                >
                  <img
                    className=""
                    src={icon}
                    height="27"
                    width="27"
                    alt={name}
                  />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
